module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.ab956f7a.jpeg";